import {FiExternalLink} from "react-icons/fi";
import {Link} from "react-router";

import {ChecksModalButton} from "@/components/ChecksModalButton/ChecksModalButton.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {MAX_VISIBLE_CHECKS} from "@/lib/constants/maintenance.ts";
import {ChecksQueryModelType} from "@/lib/queries/checks.ts";
import {Service} from "@/lib/types/checks.ts";

type AffectedChecksCellProps = {
  services: Pick<Service, "id" | "name">[];
  count: number;
  modelId: number;
  modelType: ChecksQueryModelType;
  title: string;
  onClose?: () => void;
};

export const AffectedChecksCell = ({services, count, modelId, modelType, title, onClose}: AffectedChecksCellProps) => {
  if (count === 0) {
    return <span className="pulseTextBodySmall pulse-color-gray-500">None</span>;
  }

  const visibleServices = services.slice(0, MAX_VISIBLE_CHECKS);
  const remainingCount = count - visibleServices.length;

  return (
    <div className="d-flex flex-column gap-1">
      {visibleServices.map((service) => (
        <Link
          key={service.id}
          to={`/checks/${service.id}`}
          target="_blank"
          className="d-flex align-items-center text-decoration-none"
        >
          <span className="ellipsis-overflow pulseTextBodySmall pulse-color-gray-800">{service.name}</span>
          <Icon icon={FiExternalLink} className="pulse-color-gray-500" />
        </Link>
      ))}
      {remainingCount > 0 && (
        <ChecksModalButton
          id={modelId}
          numberOfChecks={count}
          model_type={modelType}
          title={title}
          onClose={onClose}
          inline
        >
          {`+ ${remainingCount} more`}
        </ChecksModalButton>
      )}
    </div>
  );
};
